module.exports = __webpack_public_path__ + "static/img/wechat_join.e3f53a15.png";